import { SubmitButton } from "../../components/shared/buttons/submit-button";
import DetailItem from "../../components/shared/details/DetailItem";
import DetailSection from "../../components/shared/details/DetailSection";
import Typography from "../../components/shared/typography";
import { formatPhoneNumberToHumanReadable } from "../../components/utls/utils";
import { useMedicalRecordRequestDetailContext } from "../context/MedicalRecordRequestDetailContext";

export function ContactDetailsCard() {
  const {
    contactDetails,
    isEditable,
    openContactModal,
    handleUseContactFax,
    openEditContactDetail,
  } = useMedicalRecordRequestDetailContext();
  return (
    <DetailSection
      title="Contact Details"
      description="Reference numbers pulled from provider and institution records."
      actions={
        isEditable ? (
          <SubmitButton size="sm" color="beige" onClick={openContactModal}>
            Add Contact
          </SubmitButton>
        ) : null
      }
      tone="neutral"
    >
      {contactDetails.length === 0 ? (
        <Typography variant="body2" className="text-terracotta/70">
          No contact details provided.
        </Typography>
      ) : (
        contactDetails.map((detail) => (
          <DetailItem
            key={
              detail.id ??
              detail.email ??
              detail.fax ??
              detail.phone ??
              Math.random()
            }
            label={detail.department ?? "Contact"}
            helperText={detail.is_primary ? "Primary contact" : undefined}
            value={
              <div className="space-y-1 text-brown-800">
                {detail.department && (
                  <div>Department: {detail.department}</div>
                )}
                {detail.phone && (
                  <div>
                    Phone: {formatPhoneNumberToHumanReadable(detail.phone)}
                  </div>
                )}
                {detail.fax && (
                  <div>Fax: {formatPhoneNumberToHumanReadable(detail.fax)}</div>
                )}
                {detail.email && <div>Email: {detail.email}</div>}
                {isEditable && (
                  <div className="flex flex-wrap gap-2">
                    <SubmitButton
                      size="sm"
                      color="terracotta"
                      onClick={() => handleUseContactFax(detail.fax)}
                      isDisabled={!detail.fax}
                    >
                      Use Fax
                    </SubmitButton>
                    {detail.id && (
                      <SubmitButton
                        size="sm"
                        color="beige"
                        onClick={() => openEditContactDetail(detail)}
                      >
                        Edit
                      </SubmitButton>
                    )}
                  </div>
                )}
              </div>
            }
          />
        ))
      )}
    </DetailSection>
  );
}

export default ContactDetailsCard;
